/**
 * Published legal document versions and URLs — keep in sync with
 * PlatformServices/SaaSFoundation/backend/app/core/legal.py and frontend/src/utils/legal.js
 */
export const CURRENT_BAA_VERSION = '2026-07-13';
export const CURRENT_TERMS_VERSION = '2026-07-29';
export const CURRENT_PRIVACY_VERSION = '2026-07-29';
export const CURRENT_PATIENT_PORTAL_TERMS_VERSION = '2026-07-29';

export const LEGAL_ENTITY_NAME = 'BlackPepper Labs';
export const PLATFORM_NAME = 'Agentic Practice';

/** SaaS Foundation host serves /terms, /privacy, /baa (port 3001 locally). */
export function getLegalBaseUrl() {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }
  return `${protocol}//${hostname}`;
}

export const legalBaaUrl = () => `${getLegalBaseUrl()}/baa`;
export const legalTermsUrl = () => `${getLegalBaseUrl()}/terms`;
export const legalPrivacyUrl = () => `${getLegalBaseUrl()}/privacy`;
export const legalPatientPortalTermsUrl = () => `${getLegalBaseUrl()}/terms/patient-portal`;
